import React, { useEffect, useState } from 'react';

interface CountdownTimerProps {
  durationInSeconds: number;
  processAfterTimerStopped?: () => void | null;
  text?: string | null;
}

const CountdownTimer = ({ durationInSeconds, processAfterTimerStopped, text = null }: CountdownTimerProps) => {
  const [timeLeft, setTimeLeft] = useState(durationInSeconds);

  let intervalId: NodeJS.Timeout;
  useEffect(() => {
    intervalId = setInterval(() => {
      setTimeLeft((prevTimeLeft) => prevTimeLeft - 1);
    }, 1000);
  }, []); // Runs once on component mount

  useEffect(() => {
    if (timeLeft <= 0) {
      intervalId && clearInterval(intervalId);
      processAfterTimerStopped && processAfterTimerStopped(); // Call this function immediately if timeLeft is 0
    }
  }, [timeLeft]); // Re-run effect when timeLeft changes

  // Format time left into hours, minutes, and seconds
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor((timeLeft % 3600) / 60);
  const seconds = timeLeft % 60;

  return (
    <div className="mt-2 text-storygreen">
      {text && <p>{text}</p>}
      <b>{`${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds
        .toString()
        .padStart(2, '0')}`}</b>
    </div>
  );
};

export default CountdownTimer;
